import { CmsPagePanel } from '../../models/content';

/** A Panel grid panel as the sections editor holds it: the stored fields plus
 *  a transient preview link for its image. */
export type EditablePanel = CmsPagePanel & { preview?: string | null };

/**
 * The stored shape of one panel: trimmed, blank fields omitted, the preview
 * link dropped. A half-filled link is an author mid-edit, not content.
 *
 * Background and Text colour (#264) store nothing when blank, so a panel
 * nobody coloured saves exactly as it did before they existed.
 */
export function toStoredPanel(p: EditablePanel): CmsPagePanel {
  const label = p.link?.label?.trim();
  const target = p.link?.target?.trim();
  return {
    heading: p.heading.trim(),
    ...(p.copy?.trim() ? { copy: p.copy.trim() } : {}),
    ...(typeof p.imageFileId === 'number' ? { imageFileId: p.imageFileId } : {}),
    ...(p.imageAlt?.trim() ? { imageAlt: p.imageAlt.trim() } : {}),
    ...(label && target ? { link: { label, target } } : {}),
    ...(p.background ? { background: p.background } : {}),
    ...(p.textColour ? { textColour: p.textColour } : {}),
  };
}
